import { Component, signal } from '@angular/core';
import { HpaServiceService } from '../../../Services/HPAService/hpa-service.service';
import { HpaSharedServiceService } from '../../../Services/HPAService/hpa-shared-service.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CadService } from '../../../Services/CADServices/cad.service';
import { v4 as uuidv4 } from 'uuid';
import { SharedDataService } from '../../../Services/SharedServices/shared-data.service';
import { environment } from '../../../../Environment/environment';
import { Router } from '@angular/router';
@Component({
  selector: 'app-hpa-second-selection',
  templateUrl: './hpa-second-selection.component.html',
  styleUrl: './hpa-second-selection.component.css'
})
export class HpaSecondSelectionComponent {
  signalStatus:boolean=false;
  panelOpenState = signal(this.signalStatus);
  constructor(private sharedDataService: SharedDataService,private hpaservice:HpaServiceService, private hpaSharedService:HpaSharedServiceService,private formBuilder:FormBuilder,private cadService: CadService, private router: Router) {
    this.AssetbasePath = environment.assetsPath;
  };
  AssetbasePath:any;
  size:any;
  ratio:any;
  speed:any;
  dutyCycle:any;
  Series:any;
  formSubmitted = false;
  inputUnitVersion:any;
  inputType:any;
  finalData:any={
    location:"",
    code:""
  };
  CADfileFormat={
    CAD2DFileFormat:'.dxf',
    CAD3DFileFormat:'.stp',
  };
  additionalSpecData:any={
    fanThermal:"",
    InertiaHollowShaftFankg:"",
    InertiaHollowShaftFanlb:"",
    InertiaSolidShaftFankg:"",
    InertiaSolidShaftFanlb:"",
    InertiaHollowlb:"",
    InertiaHollowkg:"",
    InertiaSolidlb:"",
    InertiaSolidkg:"",
    Low_Backlash:"",
    Std_Backlash:""
  };
  inputOutputShaft:any;
  inputAssemblyPosition:any;
  inputMotorAdaptor:any;
  inputSpecialFeature:any;
  productCode:any;
  isMotorAdaptorDisabled: boolean = false;
  reducerSelectionForm = this.formBuilder.group({
    inputUnitVersion:[null, Validators.required],
    inputType:[null, Validators.required],
    inputOutputShaft:[null, Validators.required],
    inputAssemblyPosition:[null,Validators.required],
    inputMotorAdaptor:[null,Validators.required],
    inputSpecialFeature:[null,Validators.required],
  });
  assembleCode={
    series:"A",
    size:"",
    revision:"5",
    ratio:"",
    untiversion:"",
    inputType:"",
    outputshaft:"",
    inputspeed:"",
    assemblyposition:"",
    motoradaptor:"",
    specialfeature:"",
    motoradaptorHide:""
};
specData1:any={};
specData:any={};
 public showspinfo: boolean = false;
 public showcdinfo: boolean = false;
ngOnInit(){
  const currentUrl = window.location.href.toLowerCase();
  if (currentUrl.includes('spineatools') ) {
      this.showspinfo = true;
      this.showcdinfo = false;
    } else {
      this.showspinfo = false;
      this.showcdinfo = true;
    }
  this.hpaSharedService.getFormData().subscribe(data => {
    this.dutyCycle = data.selectedDutyCycle; 
  });
  this.hpaSharedService.getSeriesData().subscribe(data => {
    this.Series = data;
    console.log("MY SERIESSSSSSSS IS FROM HPAAA", data);
    
  });
  this.hpaSharedService.specification$.subscribe((specificationData:any) => 
    {
      this.specData= specificationData;
      console.log("I am in Data", this.specData);
    });


  this.hpaSharedService.productSpecification$.subscribe((data:any) => 
    {
      this.specData1=data;
      console.log("Product Details From 2nd hpa", this.specData);
    });
  this.hpaSharedService.size$.subscribe((sizeData:any) => 
    {
      // this.size = sizeData.size.replace(/[a-zA-Z]/g, '');
      console.log("Data of set size rato and speed", sizeData);
      this.size = sizeData.size;
      this.ratio = sizeData.ratio;
      this.speed = sizeData.speed;
      this.assembleCode.size = sizeData.size;
      this.assembleCode.ratio = sizeData.ratio;
      this.assembleCode.inputspeed = sizeData.speed;
      this.getUnitVersion();
    });
}
private getUnitVersion():void{
  this.signalStatus=true;
  this.panelOpenState = signal(this.signalStatus);
  this.hpaservice.getUnitVersion().subscribe(result=>{
     this.inputUnitVersion = Object.keys(result).map(key => ({
       key: key,
       value: result[key]
     }));
     console.log("Unit Version", this.inputUnitVersion);
  },
 (error)=>{
   console.error('Error fetching in unitversion :', error);
 });
 }
 private getInputType():void{
  const rgImage = document.getElementById('rgImage') as HTMLInputElement;
  rgImage.src = this.AssetbasePath+"/Content/HPAImages/HPA.png";
  this.hpaservice.getInputType().subscribe(result=>{
    this.inputType = Object.keys(result).map(key => ({
      key: key,
      value: result[key]
    }));
    console.log("Input Type", result);
  },
  (error)=>{
    console.error('Error fetching in type of unit :', error);
  });
}
private getOutputShaft(size:any):void{
  const rgImage = document.getElementById('rgImage') as HTMLInputElement;
  rgImage.src = this.AssetbasePath+"/Content/HPAImages/Col11.png";
  this.hpaservice.getOutputShaft(size).subscribe(result=>{
    this.inputOutputShaft = Object.keys(result).map(key => ({
      key: key,
      value: result[key]
    }));
    console.log("Output Shaft", result);
  },
  (error)=>{
    console.error('Error fetching in Output Shaft :', error);
  });
}
private getMotorAdaptor(typeOfUnit:any,size:any){
  const rgImage = document.getElementById('rgImage') as HTMLInputElement;
  rgImage.src = this.AssetbasePath+"/Content/HPAImages/HPA.png";
  this.hpaservice.getMotorAdaptor(typeOfUnit,size).subscribe(result=>{
  this.inputMotorAdaptor = Object.keys(result).map(key => ({
      key: key,
      value: result[key]
    }));
    console.log("Motor Adaptor", result);
  },
  (error)=>{
    console.error('Error fetching in motor adaptor :', error);
  });
}
private getAssemblyPosition(outputshaft:any):void{
  const rgImage = document.getElementById('rgImage') as HTMLInputElement;
  rgImage.src = this.AssetbasePath+"/Content/HPAImages/AsmPos.png";
  this.hpaservice.getAssemblyPosition(outputshaft).subscribe(result=>{
    this.inputAssemblyPosition = Object.keys(result).map(key => ({
      key: key,
      value: result[key]
    }));
    console.log("Assembly Position", result);
  },
  (error)=>{
    console.error('Error fetching in assembly position :', error);
  });
}
private getSpecialfeature(){
  debugger;
  const rgImage = document.getElementById('rgImage') as HTMLInputElement;
  rgImage.src = this.AssetbasePath+"/Content/HPAImages/Col15.png";
  this.hpaservice.getSpecialFeatures(this.dutyCycle,this.Series).subscribe(result=>{
    
    this.inputSpecialFeature = Object.keys(result).map(key => ({
      key: key,
      value: result[key]
    }));
    
 },
(error)=>{
  console.error('Error fetching in special feature :', error);
});
}
 onUnitVersionChange(event:any){
  this.assembleCode.untiversion = event.target.value;
this.getInputType();
this.resetDependentDropdowns(['inputType']);
 }
 onInputTypeChange(event:any){
  this.assembleCode.inputType = event.target.value;
  this.getOutputShaft(this.size);
  this.resetDependentDropdowns(['inputOutputShaft']);
 }
 oninputOutputShaftChange(event:any){
  const motorAdaptor:any = this.reducerSelectionForm.get('inputMotorAdaptor');
  this.assembleCode.outputshaft = event.target.value;
  const motorEle = document.getElementById("inputMotorAdaptor") as HTMLInputElement;

  if(this.assembleCode.inputType == "A" || this.assembleCode.inputType == "B"){
    if(motorEle.disabled == true){
      motorEle.disabled = false;
    }
    if (motorAdaptor.hasValidator(Validators.required)) {
    } else {
      // Add the required validator
      motorAdaptor.setValidators(Validators.required);
    }
    this.getMotorAdaptor(this.assembleCode.inputType,this.size);
    this.resetDependentDropdowns(['inputMotorAdaptor']);
  }else{
    motorAdaptor.clearValidators();
    this.isMotorAdaptorDisabled=true;
    this.assembleCode.motoradaptor="";
    this.reducerSelectionForm.get('inputMotorAdaptor')?.setValue(null);
    motorEle.disabled = true;

    this.getAssemblyPosition(this.assembleCode.assemblyposition);
    this.resetDependentDropdowns(['inputAssemblyPosition']);
  }
  // this.resetDependentDropdowns(['inputMotorAdaptor']);
// this.getMotorAdaptor(this.assembleCode.inputType, this.size);
 }
 oninputMotorAdaptorChange(event:any){
this.assembleCode.motoradaptor = event.target.value;
this.getAssemblyPosition(this.assembleCode.assemblyposition);
this.resetDependentDropdowns(['inputAssemblyPosition']);
 }
 oninputAssemblyPositionChange(event:any){
  this.assembleCode.assemblyposition = event.target.value;
  this.getSpecialfeature();
  this.resetDependentDropdowns(['inputSpecialFeature']);
 }
 oninputSpecialFeatureChange(event:any){
this.assembleCode.specialfeature = event.target.value;
 }
 private resetDependentDropdowns(dropdownNames: string[]) {
  dropdownNames.forEach(name => {
    this.reducerSelectionForm.get(name)?.reset();
  });
}
 rgReducerButton(){
  this.formSubmitted = true;

  // if(this.ratio.length==1){
  //   this.assembleCode.ratio = this.ratio+".0";
  // }else if(this.ratio.length==2){
  //   this.assembleCode.ratio = this.ratio+".";
  // }
if(this.assembleCode.inputType == "A" || this.assembleCode.inputType == "B"){
  this.productCode = this.assembleCode.series + this.assembleCode.size + this.assembleCode.revision
                    + this.assembleCode.ratio + this.assembleCode.untiversion + this.assembleCode.inputType
                    + this.assembleCode.outputshaft + this.assembleCode.motoradaptor + this.assembleCode.assemblyposition
                    + "-" + this.assembleCode.specialfeature;
}else{
  this.productCode = this.assembleCode.series + this.assembleCode.size + this.assembleCode.revision
  + this.assembleCode.ratio + this.assembleCode.untiversion + this.assembleCode.inputType
  + this.assembleCode.outputshaft + "-" + this.assembleCode.assemblyposition
  + "-" + this.assembleCode.specialfeature;
}

console.log("Code is:", this.productCode);
this.hpaSharedService.setProductCode(this.productCode);
this.sharedDataService.setCADChangeStatus("true");
  
  this.getAllproductDetail();
  this.updateSpecification();
  this.createCAD();
 }




 getAllproductDetail(){
  const unitversion = document.getElementById("inputUnitVersion") as HTMLSelectElement;
  const typeOfUnit = document.getElementById("inputType") as HTMLSelectElement;
  const OutputShaft = document.getElementById("inputOutputShaft") as HTMLSelectElement;
  const assemblyPosition = document.getElementById("inputAssemblyPosition") as HTMLSelectElement;
  const motorAdaptor = document.getElementById("inputMotorAdaptor") as HTMLSelectElement;
  const specialFeature = document.getElementById("inputSpecialFeature") as HTMLSelectElement;
  const prodDetails={
    size:this.assembleCode.size,
    ratio: this.assembleCode.ratio,
    unitversion: unitversion.options[unitversion.selectedIndex].text.replace(/^.*? - /, ''),
    unitversionValue:unitversion.value,
    typeOfUnit: typeOfUnit.options[typeOfUnit.selectedIndex].text.replace(/^.*? - /, ''),
    typeOfUnitValue: typeOfUnit.value,
    OutputShaft: OutputShaft.options[OutputShaft.selectedIndex].text.replace(/^.*? - /, ''),
    OutputShaftValue: OutputShaft.value,
    handOfAssembly: assemblyPosition.options[assemblyPosition.selectedIndex].text,
    handOfAssemblyValue: assemblyPosition.value,
    motorAdaptor: motorAdaptor.options[motorAdaptor.selectedIndex].text.replace(/^.*? - /, ''),
    motorAdaptorValue:motorAdaptor.value,
    specialFeature: specialFeature.options[specialFeature.selectedIndex].text,
    specialFeatureValue:specialFeature.value,
    speed:this.assembleCode.inputspeed,
  };
  this.hpaSharedService.setProductSpecification(prodDetails);
 }



 updateSpecification(){
  debugger;
  const unitversion = document.getElementById("inputUnitVersion") as HTMLInputElement;
  const OutputShaft = document.getElementById("inputOutputShaft") as HTMLSelectElement;
  const specialFeature = document.getElementById("inputSpecialFeature") as HTMLSelectElement;
  const inputType = document.getElementById("inputType") as HTMLSelectElement;


  if(this.assembleCode.inputspeed=="1150" || this.assembleCode.inputspeed=="1750"){
    switch(specialFeature.options[specialFeature.selectedIndex].text){
      case "B":
      case "F":
      case "G":
      case "I":
      case "K":
      case "M":
      case "N":
      case "O":
              this.additionalSpecData.fanThermal = parseFloat((parseFloat(this.specData.fan_Thermal) * 0.7456999).toFixed(1))
              break;
    }
  }
  if((specialFeature.options[specialFeature.selectedIndex].value == "B") || (specialFeature.options[specialFeature.selectedIndex].value == "F") || (specialFeature.options[specialFeature.selectedIndex].value == "G")|| (specialFeature.options[specialFeature.selectedIndex].value == "I")|| (specialFeature.options[specialFeature.selectedIndex].value == "K")|| (specialFeature.options[specialFeature.selectedIndex].value == "M")|| (specialFeature.options[specialFeature.selectedIndex].value == "N")|| (specialFeature.options[specialFeature.selectedIndex].value == "O")){
    switch(inputType.options[inputType.selectedIndex].value){
      case "A":
      case "H":
              this.additionalSpecData.InertiaHollowShaftFankg = this.specData.inertiaHollowShaftFankg;
              this.additionalSpecData.InertiaHollowShaftFanlb = this.specData.inertiaHollowShaftFanlb;
              break;
      case "B":
      case "N":
      case "P":
      case "T":
      case "Q":
      case "G":
      case "E":
      case "C":
      case "D":
      case "M":
      case "L":
      case "R":
              this.additionalSpecData.InertiaSolidShaftFankg = this.specData.inertiaSolidShaftFankg;
              this.additionalSpecData.InertiaSolidShaftFanlb = this.specData.inertiaHollowShaftFanlb;
              break;
    }
  }else{
    switch(inputType.options[inputType.selectedIndex].value){
      case "A":
      case "H":
              this.additionalSpecData.InertiaHollowkg = this.specData.inertiaHollowkg;
              this.additionalSpecData.InertiaHollowlb = this.specData.inertiaHollowlb;
              break;
      case "B":
      case "N":
      case "P":
      case "T":
      case "Q":
      case "G":
      case "E":
      case "C":
      case "D":
      case "M":
      case "L":
      case "R":
              this.additionalSpecData.InertiaSolidkg = this.specData.inertiaSolidkg;
              this.additionalSpecData.InertiaSolidlb = this.specData.inertiaSolidlb;
              break;
    }
    
  }

    switch(specialFeature.options[specialFeature.selectedIndex].value){
      case "B":
      case "E":
      case "H":
      case "J":
      case "L":
      case "M":
      case "N":
      case "O":
              this.additionalSpecData.Low_Backlash = this.specData.low_Backlash;
              break;
      default:
              this.additionalSpecData.Std_Backlash = this.specData.std_Backlash;
              break;
    }


  this.hpaSharedService.setFinalSpecification(Object.assign({}, this.specData, this.additionalSpecData));
//   var rees =    Object.assign({}, this.specData, this.additionalSpecData)
// console.log("MY RESULT:", rees);



  
  
  // this.GetWeightslb(OutputShaft.options[OutputShaft.selectedIndex].text, this.specData.size)
  // this.GetWeightskg(OutputShaft.options[OutputShaft.selectedIndex].text, this.specData.size)
  // this.rgSharedService.setFinalSpecification(Object.assign({}, this.specData, this.AccuSpecModel))
  // console.log("Combined Data", Object.assign({}, this.specData, this.AccuSpecModel) );
}

createCAD():void {
  debugger;
  const cadData={
    Website:"HPA",
    Guid: uuidv4(),
    Code:this.productCode.toString().trim(),
    asmFormat:this.CADfileFormat.CAD3DFileFormat.toString().trim(),
    dwgFormat:this.CADfileFormat.CAD2DFileFormat.toString().trim(),
    MotorFrame: "",
    FlangType:"",
    ShaftDia:"",
    TimeIn:this.getCurrentFormattedDate(),
    ClientIP:"10.248.24.1"
  };
  debugger;
  // this.finalData.cadLocation = cadData.Guid;
  this.finalData.location = cadData.Guid;
  this.finalData.code = cadData.Code;
  this.hpaSharedService.setCadData(this.finalData);
  this.cadService.GenerateCADLoadbalancing(cadData);

  }

getCurrentFormattedDate(): string {
  const now = new Date();

  // Helper function to pad single-digit numbers with leading zero
  const dateData = (num: number) => num.toString().padStart(2, '0');

  return `${now.getFullYear()}-${dateData(now.getMonth() + 1)}-${dateData(now.getDate())}T${dateData(now.getHours())}:${dateData(now.getMinutes())}:${dateData(now.getSeconds())}`;
}
}


